import { KeyInfoInterface } from '@/interfaces/KeyInfoInterface';
import AbstractFilterMultipleEnum from '@/components/CustomFilter/AbstractFilterMultipleEnum';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';
import { Component, Prop } from 'vue-property-decorator';
import { OrderStatusEnum, OrderStatusKeyInfo } from '@/items/OrderStatus';

@Component<OrderStatusFilter>({})
export default class OrderStatusFilter extends AbstractFilterMultipleEnum implements FilterInterface {

  // #region @Props

  @Prop({ default: 'order_statuses' })
  protected filterStorageKey!: string;

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({ default: () => OrderStatusEnum })
  protected enum!: Record<string, string>;

  @Prop({ default: () => OrderStatusKeyInfo })
  protected enumKeyInfo!: Record<string, KeyInfoInterface>;

  @Prop({ default: 'Order status' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Order status' })
  protected placeholderSearch!: string;

  @Prop({ default: false })
  protected showSearchField!: boolean;

  // #endregion
}
